<template>
  <div>
    <breadcrumb :items="breadcrumbs"></breadcrumb>
    <v-container fluid class="mt-5">
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
        @submit.prevent="registerGeno"
      >
        <div class="registration-section">
          <div class="main-register">
            <div class="registration-heading">
              <h2>{{ $t('genoPerformance.genoTypeRegistration') }}</h2>
            </div>
            <div class="registration-btn">
              <v-btn
                width="146"
                class="mr-2"
                :to="{ name: 'GenoList' }"
                outlined
                exact
                color="primary"
                >{{ $t('cancel') }}</v-btn
              >
              <v-btn type="submit" width="146" color="primary">{{ $t('submit') }}</v-btn>
            </div>
          </div>
          <h2 class="mandatory">* {{ $t("mandatory") }}</h2>
          <v-card elevation="0" class="px-5">
            <div class="geno-form">
              <v-row class="pa-5">
                <v-col cols="12"></v-col>
                <v-col lg="4" md="4" sm="6" xs="6">
                  <div class="form-group">
                    <div class="cell-2">
                      <label for="text">{{ $t('genoPerformance.breedName') }} <span>*</span></label>
                    </div>
                    <v-select
                      :items="breeds"
                      item-value="id"
                      item-text="name"
                      v-model="genoToAdd.breedId"
                      placeholder="Senepol"
                      outlined
                      dense
                      :rules="genoRules.breedId"
                    ></v-select>
                  </div>
                </v-col>
                <v-col lg="4" md="4" sm="6" xs="6">
                  <div class="form-group">
                    <label for="number">{{ $t('genoPerformance.chromosome') }} <span>*</span></label>
                    <v-text-field
                      type="number"
                      v-model="genoToAdd.chromosome"
                      placeholder="33"
                      outlined
                      dense
                      :rules="genoRules.chromosome"
                    ></v-text-field>
                  </div>
                </v-col>
                <v-col lg="4" md="4" sm="6" xs="6">
                  <div class="form-group">
                    <label for="text">{{ $t('genoPerformance.sequenceChange') }} <span>*</span></label>
                    <v-text-field
                      v-model="genoToAdd.sequenceChange"
                      placeholder="g.76854"
                      outlined
                      dense
                      :rules="genoRules.sequenceChange"
                    ></v-text-field>
                  </div>
                </v-col>
                <v-col lg="4" md="4" sm="6" xs="6">
                  <div class="form-group">
                    <label for="text">{{ $t('genoPerformance.inheritance') }} <span>*</span></label>
                    <v-select
                      :items="inheritances"
                      item-value="name"
                      item-text="name"
                      v-model="genoToAdd.inheritance"
                      placeholder="Dominant"
                      outlined
                      dense
                      :rules="genoRules.inheritance"
                    ></v-select>
                  </div>
                </v-col>
                <v-col lg="4" md="4" sm="6" xs="6">
                  <div class="form-group">
                    <label for="text">{{ $t('genoPerformance.diseaseName') }} <span>*</span></label>
                    <v-text-field
                      v-model="genoToAdd.diseaseName"
                      placeholder="Silk hair"
                      outlined
                      dense
                      :rules="genoRules.diseaseName"
                    ></v-text-field>
                  </div>
                </v-col>
                <v-col lg="4" md="4" sm="6" xs="6">
                  <div class="form-group">
                    <label for="text">{{ $t('genoPerformance.referenceSequence') }} <span>*</span></label>
                    <v-text-field
                      v-model="genoToAdd.referenceSequence"
                      placeholder="Bos_tairas_UMD"
                      outlined
                      dense
                      :rules="genoRules.referenceSequence"
                    ></v-text-field>
                  </div>
                </v-col>
                <v-col lg="4" md="4" sm="6" xs="6">
                  <div class="form-group">
                    <label for="straws">{{ $t('genoPerformance.pubmedReference') }} <span>*</span></label>
                    <v-text-field
                      v-model="genoToAdd.pubmedReference"
                      placeholder="3456789"
                      outlined
                      dense
                      :rules="genoRules.pubmedReference"
                    ></v-text-field>
                  </div>
                </v-col>
                <v-col cols="8"></v-col>
                <v-col cols="12"></v-col>
              </v-row>
            </div>
          </v-card>
          <div class="registration-btn bottom-btn">
            <v-btn
              width="146"
              class="mr-2"
              :to="{ name: 'GenoList' }"
              outlined
              exact
              color="primary"
              >{{ $t('cancel') }}</v-btn
            >
            <v-btn width="146" type="submit" color="primary">{{ $t('submit') }}</v-btn>
          </div>
        </div>
      </v-form>
    </v-container>
  </div>
</template>

<script>
import loading from "@/mixins/LoadingMixin";
import { genoRules } from "@/validations/GenoFormRules.js";
import gql from "graphql-tag";
import { breeds } from "@/graphql/Animals.gql";
export default {
  apollo: {
    breeds: {
      query: breeds,
    },
  },
  data() {
    return {
      breeds: [],
      genoRules,
      valid: true,
      inheritances: [
        { name: "dominant ", id: "1" },
        { name: "recesive", id: "2" },
        { name: "additive", id: "3" },
        { name: "overdominant", id: "4" },
      ],
      breadcrumbs: [
        {
          text: this.$t('dashboard'),
          disabled: false,
          to: "/",
        },
        {
          text: this.$t('genoPerformance.performanceOfGenoType'),
          disabled: false,
          exact: true,
          link: true,
          to: { name: "GenoList" },
        },
        {
          text: this.$t('genoPerformance.genoTypeRegistration'),
          disabled: true,
          href: "breadcrumbs_link_1",
        },
      ],
      genoToAdd: {},
    };
  },
  methods: {
    async registerGeno() {
      if (!this.$refs.form.validate()) return;
      this.startLoading();

      let payload = {
        userId: parseInt(this.$store.getters.getUser.userDetail.id),
        breedId: parseInt(this.genoToAdd.breedId) ?? null,
        chromosome: parseInt(this.genoToAdd.chromosome) ?? null,
        diseaseName: this.genoToAdd.diseaseName ?? null,
        inheritance: this.genoToAdd.inheritance ?? null,
        pubmedReference: this.genoToAdd.pubmedReference ?? null,
        referenceSequence: this.genoToAdd.referenceSequence ?? null,
        sequenceChange: this.genoToAdd.sequenceChange ?? null,
      };

      await this.$apollo
        .mutate({
          mutation: gql`
            mutation CreateGenotypePerformance(
              $createGenotypePerformanceInput: CreateGenotypePerformanceInput!
            ) {
              createGenotypePerformanceRecord(
                createGenotypePerformanceInput: $createGenotypePerformanceInput
              ) {
                id
              }
            }
          `,
          variables: {
            createGenotypePerformanceInput: payload,
          },
        })
        .then((res) => {
          if (res.data.createGenotypePerformanceRecord) {
            this.$notify({
              title: "GenoType Registered",
              text: res.message,
              type: "success",
            });

            this.$router.push({ name: "GenoList" });
          } else {
            this.$notify({
              title: "GenoType Not Registered",
              text: res.message,
              type: "error",
            });
          }
        })
        .catch((error) => {
          console.log("error", error.message);
          this.$notify({
            title: "",
            text: "Something went wrong while register genotype performance",
            type: "error",
          });
        });

      this.stopLoading();
    },
  },
  mixins: [loading],
};
</script>

<style lang="scss">
.registration-section .main-register {
  display: flex;
  justify-content: space-between;
}
.registration-heading {
  display: flex;
  align-items: center;
}
.registration-section .registration-heading h2 {
  /* color:#6A7784; */
  /* font-size: 20px; */
  font-family: Poppins-Medium;
}
.registration-section .registration-heading span {
  width: 1px;
  height: 30px;
  /* background: #6A7784; */
  margin: 0px 15px;
}
.registration-section .registration-heading p {
  /* color: #97A8B8; */
  font-size: 20px;
  font-family: Poppins-Medium;
}
.registration-btn {
  display: flex;
  align-items: center;
}
.registration-btn.bottom-btn {
  margin: 30px 22px 0px 0px;
  justify-content: flex-end;
  padding: 24px 15px;
  border-top: 1px solid #dae1ec;
  width: 100%;
}
.mandatory {
  font-size: 14px;
  font-weight: 100;
  font-family: pop_light;
  margin: 20px 0px;
}
.accordion {
  cursor: pointer;
  padding: 10px;
  width: 100%;
  text-align: left;
  transition: 0.4s;
  background: #fafcff;
  border: 1px solid #c7d5e1;
  /* color: #6A7784; */
  font-size: 14px;
  font-family: pop_semiBold;
  margin-bottom: 15px;
  border-radius: 5px;
}
.panel {
  /* padding: 15px 15px; */
  background-color: white;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.2s ease-out;
  margin-bottom: 20px;
}
.geno-form.margin-cell-3 {
  margin-top: 20px;
}
.geno-form {
  display: inline;
}
.geno-form label {
  display: inline-block;
  margin-bottom: 0.5rem;
  /* color: #97A8B8; */
  font-size: 14px;
  font-family: Poppins-Medium;
  letter-spacing: 0.5px;
  white-space: nowrap;
}
.geno-form .form-control {
  display: block;
  width: 100%;
  height: 50px;
  padding: 0.375rem 0.75rem;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  //   color: #495057;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  background: #fff;
  border: 1px solid #c7d5e1;
  border-radius: 3px;
  color: #c7d5e1;
  font-family: pop_regular;
}
.geno-form .form-control:focus-visible,
.form-control-2:focus-visible {
  outline: none;
}
.geno-form .form-control::placeholder {
  font-size: 14px;
  color: #c7d5e1;
  font-family: pop_regular;
}
.geno-form .form-control-2 {
  display: block;
  width: 100%;
  height: 50px;
  padding: 1px 20px;
  line-height: 1.5;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  background: #fff;
  border: 1px solid #c7d5e1;
  border-radius: 3px;
  background-position: calc(100% - 1.2rem) center !important;
  -moz-appearance: none !important;
  -webkit-appearance: none !important;
  appearance: none !important;
  /* background-image: url(../img/drop2.png); */
  background-repeat: no-repeat;
  font-size: 14px;
  color: #c7d5e1;
  font-family: pop_regular;
}
.cell-2 {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.cell-2 h2 {
  font-size: 14px;
  color: #70a4d3;
  font-family: Poppins-Medium;
  font-weight: 100;
}
.form-group {
  margin-top: -20px;
}
.form-group span {
  color: red;
}
</style>
